import Enum from '@/modules/core/app/helpers/Enum';
import { EstateDetailsMainTabValue } from '@/modules/ops/constants/EstateDetailsMainTabValue';
import { EstateDetailsCollapsesTabValue } from '@/modules/ops/constants/EstateDetailsCollapsesTabValue';

// A null tab means the estate page has no place that shows the section, so no link is offered.
export class MessageClaraDraftSourceSection extends Enum {
  key!: string;
  tab!: string | null;

  static EXECUTORS: MessageClaraDraftSourceSection = {
    key: 'executors',
    tab: EstateDetailsCollapsesTabValue.DETAILS
  };

  static RESIDUAL_DISTRIBUTIONS: MessageClaraDraftSourceSection = {
    key: 'residual_distributions',
    tab: EstateDetailsCollapsesTabValue.DETAILS
  };

  static ALTERNATE_DISTRIBUTIONS: MessageClaraDraftSourceSection = {
    key: 'alternate_distributions',
    tab: EstateDetailsCollapsesTabValue.DETAILS
  };

  static WILL: MessageClaraDraftSourceSection = {
    key: 'will',
    tab: EstateDetailsMainTabValue.DOCUMENTS
  };

  static POWER_OF_ATTORNEY: MessageClaraDraftSourceSection = {
    key: 'power_of_attorney',
    tab: EstateDetailsMainTabValue.DOCUMENTS
  };

  static PROTECTION_MANDATE: MessageClaraDraftSourceSection = {
    key: 'protection_mandate',
    tab: EstateDetailsMainTabValue.DOCUMENTS
  };

  static SIGNING_DOCUMENTS: MessageClaraDraftSourceSection = {
    key: 'signing_documents',
    tab: EstateDetailsMainTabValue.DOCUMENTS
  };

  static TYPICAL_OUTSTANDING_FROM_CLIENT: MessageClaraDraftSourceSection = {
    key: 'typical_outstanding_from_client',
    tab: EstateDetailsMainTabValue.STEPS
  };

  static GUARDIANS: MessageClaraDraftSourceSection = { key: 'guardians', tab: null };

  static PET_GUARDIANS: MessageClaraDraftSourceSection = { key: 'pet_guardians', tab: null };

  static POA_PROPERTY: MessageClaraDraftSourceSection = { key: 'poa_property', tab: null };

  static POA_PERSONAL_CARE: MessageClaraDraftSourceSection = {
    key: 'poa_personal_care',
    tab: null
  };

  static MANDATARIES: MessageClaraDraftSourceSection = { key: 'mandataries', tab: null };

  static SPECIFIC_BEQUESTS: MessageClaraDraftSourceSection = {
    key: 'specific_bequests',
    tab: null
  };

  static FUNERAL_DISPOSITION: MessageClaraDraftSourceSection = {
    key: 'funeral_disposition',
    tab: null
  };

  static HEALTHCARE_WISHES: MessageClaraDraftSourceSection = {
    key: 'healthcare_wishes',
    tab: null
  };

  static SPOUSE: MessageClaraDraftSourceSection = { key: 'spouse', tab: null };

  static CHILDREN: MessageClaraDraftSourceSection = { key: 'children', tab: null };

  static PETS: MessageClaraDraftSourceSection = { key: 'pets', tab: null };

  static OTHER_DEPENDENTS: MessageClaraDraftSourceSection = {
    key: 'other_dependents',
    tab: null
  };
}
